var _rect, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNotii(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 22,
    fill: "#CCF2E1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 16.4404V19.7704",
    stroke: "#1E222B",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0199 12C18.3399 12 15.3599 14.98 15.3599 18.66V20.76C15.3599 21.44 15.0799 22.46 14.7299 23.04L13.4599 25.16C12.6799 26.47 13.2199 27.93 14.6599 28.41C19.4399 30 24.6099 30 29.3899 28.41C30.7399 27.96 31.3199 26.38 30.5899 25.16L29.3199 23.04C28.9699 22.46 28.6899 21.43 28.6899 20.76V18.66C28.6799 15 25.6799 12 22.0199 12Z",
    stroke: "#1E222B",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3299 28.8203C25.3299 30.6503 23.8299 32.1503 21.9999 32.1503C21.0899 32.1503 20.2499 31.7703 19.6499 31.1703C19.0499 30.5703 18.6699 29.7303 18.6699 28.8203",
    stroke: "#1E222B",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotii);
export default __webpack_public_path__ + "static/media/notii.bc5e11033fea0552f6cc89e0aa1e29a0.svg";
export { ForwardRef as ReactComponent };